/* eslint-disable react/prop-types */
import React from 'react';

import iconEyeOpen from '../../../assets/img/icon-eye-open.svg';
import iconEyeClosed from '../../../assets/img/icon-eye-closed.svg';
import iconPadlock from '../../../assets/img/icon-padlock.svg';
import { StyledInputPassword } from './styles';

const InputPasswordSimple = (props) => {
  const {
    value,
    name,
    maxLength,
    borderColor,
    placeholder,
    passwordVisibility,
    onChange,
    onChangePasswordVisibility,
  } = props;

  const handleChange = (e) => {
    onChange(e);
  }
  return (
    <StyledInputPassword borderColor={borderColor}>
      <img className="img-padlock" alt="padlock" title="padlock" src={iconPadlock} />
      <input
        name="password"
        placeholder={placeholder}
        type={passwordVisibility ? 'text' : 'password'}
        value={value}
        maxLength={maxLength}
        onChange={(e) => handleChange(e)}
        autoComplete="off"
      />
      <button
        type="button"
        tabIndex="-1"
        onClick={() => onChangePasswordVisibility(name)}
        className="btn-show-password bg-transparent border-0 p-0"
      >
        <img
          alt="eye"
          title={passwordVisibility ? 'Hide password' : 'Show password'}
          src={passwordVisibility ? iconEyeClosed : iconEyeOpen}
        />
      </button>
    </StyledInputPassword>
  );
}

export default InputPasswordSimple;
